// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-n88zR";
var _3 = "link-1fO6x";
export { _1 as "__esModule", _2 as "root", _3 as "link" }
export default { "__esModule": _1, "root": _2, "link": _3 }
